module.exports = __webpack_public_path__ + "assets/font/BLENDERBOLD-611eae2a.TTF";